import { Redirect } from 'types/suggestions';
import { patchUrlByLocale } from 'utils/patch-url-by-locale';
import { SearchHistoryItem } from '../use-search-history-context';
import { navigate } from './utils';

export const handleRedirect = (redirect: Redirect, addHistoryItem: (item: SearchHistoryItem) => void) => {
  const url = redirect.pageUrl ? getRedirectUrl(redirect.pageUrl) : getFallbackUrl(redirect.name);
  addHistoryItem({
    title: redirect.name,
    url: url,
  });
  navigate(url);
};

export const getRedirectUrl = (url: string) => {
  return patchUrlByLocale({
    url: url.endsWith('.html') ? `${url.slice(0, -5)}/` : url,
  });
};

export const getFallbackUrl = (name: string) => {
  const searchParams = new URLSearchParams();
  searchParams.append('q', name);
  searchParams.append('suggest', 'true');
  return patchUrlByLocale({ url: `/search/?${searchParams}` });
};
